import React, { useEffect } from 'react';
import { useLocalizedNavigate } from './hooks/useLocalizedNavigate';

const LocalizedNavigate = ({ pathKey, params = {}, options = {} }) => {
  const navigate = useLocalizedNavigate();

  useEffect(() => {
    navigate(pathKey, { params, options });
  }, [pathKey, params, options]);

  return <></>;
};

export default LocalizedNavigate;
